import { useState } from "react";
import { Search } from "lucide-react";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { useApi } from "../../lib/useApi";
import { CONTACT_FILTER } from "../../lib/directoryLabels";

export const EMPTY_FILTERS = { q: "", sector: "", country: "", city: "", agency: "", service: "", contact: "" };

export default function DirectoryFilters({ onApply }) {
  const [f, setF] = useState(EMPTY_FILTERS);
  const opts = useApi("/public/directory/filters").data || { sectors: [], countries: [], cities: [] };
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  return (
    <form onSubmit={(e) => { e.preventDefault(); onApply(f); }} className="card-surface grid gap-2 p-3 sm:grid-cols-2 lg:grid-cols-4" data-testid="directory-filters">
      <div className="relative sm:col-span-2">
        <Search className="absolute left-3 top-3 h-4 w-4 text-slate-400" />
        <Input value={f.q} onChange={set("q")} placeholder="Nom de l'entreprise" className="h-10 pl-9" data-testid="directory-filter-name" />
      </div>
      <select className="field-select" value={f.sector} onChange={set("sector")} data-testid="directory-filter-sector">
        <option value="">Tous les secteurs</option>
        {opts.sectors.map((s) => <option key={s} value={s}>{s}</option>)}
      </select>
      <select className="field-select" value={f.country} onChange={set("country")} data-testid="directory-filter-country">
        <option value="">Tous les pays</option>
        {opts.countries.map((c) => <option key={c} value={c}>{c}</option>)}
      </select>
      <Input list="dir-cities" value={f.city} onChange={set("city")} placeholder="Ville" className="h-10" data-testid="directory-filter-city" />
      <Input value={f.agency} onChange={set("agency")} placeholder="Agence" className="h-10" data-testid="directory-filter-agency" />
      <Input value={f.service} onChange={set("service")} placeholder="Service (ex : accueil)" className="h-10" data-testid="directory-filter-service" />
      <select className="field-select" value={f.contact} onChange={set("contact")} data-testid="directory-filter-contact">
        {CONTACT_FILTER.map(([v, l]) => <option key={v} value={v}>{v ? l : "Contact : indifférent"}</option>)}
      </select>
      <datalist id="dir-cities">{opts.cities.map((c) => <option key={c} value={c} />)}</datalist>
      <div className="flex gap-2 sm:col-span-2 lg:col-span-4 lg:justify-end">
        <Button type="button" variant="ghost" onClick={() => { setF(EMPTY_FILTERS); onApply(EMPTY_FILTERS); }} data-testid="directory-filter-reset">Réinitialiser</Button>
        <Button type="submit" className="flex-1 lg:flex-none" data-testid="directory-filter-submit">Rechercher</Button>
      </div>
    </form>
  );
}
